import script from "./build-cache-core-usage-chart-controller.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-cache-core-usage-chart-controller.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__